export default {
  baseURL: function baseURL(state) {
    return state.baseURL;
  }
};